function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count-new]').forEach((el) => {
    el.textContent = count;
  });
}

function getRealCartCount(cart) {
  if (!cart || !Array.isArray(cart.items)) return 0;
  return cart.items.reduce((count, item) => {
    if (item.properties && item.properties._package_protection) return count;
    return count + Math.max(0, Number(item.quantity) || 0);
  }, 0);
}

let cartCountRequestId = 0;

function getVisibleCartCount() {
  const el = document.querySelector('[data-cart-count-new]');
  const count = Number.parseInt(el?.textContent || '', 10);
  return Number.isFinite(count) ? count : 0;
}

function checkCartContents(cart = null) {
  if (cart && Array.isArray(cart.items)) {
    cartCountRequestId += 1;
    updateCartCount(getRealCartCount(cart));
    return Promise.resolve(cart);
  }

  const requestId = ++cartCountRequestId;
  return fetch('/cart.js')
    .then((res) => {
      if (!res.ok) throw new Error(`Cart fetch failed (${res.status})`);
      return res.json();
    })
    .then((cart) => {
      if (requestId === cartCountRequestId) {
        updateCartCount(getRealCartCount(cart));
      }
      return cart;
    })
    .catch((e) => console.error('Cart fetch error:', e));
}

function wait(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

async function restoreCartCountAfterCheckout() {
  const expectedCount = getVisibleCartCount();
  const delays = [250, 700, 1400];

  for (let index = 0; index < delays.length; index += 1) {
    if (delays[index] > 0) {
      await wait(delays[index]);
    }

    const cart = await checkCartContents();
    const count = getRealCartCount(cart);
    const isLastAttempt = index === delays.length - 1;

    if (count < expectedCount && !isLastAttempt) {
      continue;
    }

    return cart;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const cartCountEl = document.querySelector('[data-cart-count-new]');
  if (!cartCountEl) return;

  checkCartContents(); // on page load
  const ref = document.referrer || "";
  if (ref.includes("/checkout") || ref.includes("/checkouts") || ref.includes("checkout.")) {
    restoreCartCountAfterCheckout().catch((e) => console.error('Cart restore error:', e));
  }

  // ✅ Listen for cart updates triggered elsewhere
  window.addEventListener('cart:updated', (event) => {
    checkCartContents(event.detail && event.detail.cart);
  });

  // ✅ Handle back/forward cache (returning from checkout)
  window.addEventListener('pageshow', (event) => {
    const r = document.referrer || "";
    if (event.persisted || r.includes("/checkout") || r.includes("/checkouts") || r.includes("checkout.")) {
      restoreCartCountAfterCheckout().catch((e) => console.error('Cart restore error:', e));
    }
  });

  // ✅ Listen for clicks on add-to-cart buttons
  document.body.addEventListener('click', function (e) {
    const isAddBtn = e.target.closest('form[action*="/cart/add"], [data-btn-addtocart], button[name="add"]');
    if (isAddBtn) {
      setTimeout(checkCartContents, 800);
    }
  });

    document.body.addEventListener('click', function (e) {
        if (e.target.id === 'opus-shadow-container') {
        setTimeout(checkCartContents, 800);
        }
    });
});
